<script setup>
import { ref, computed, toRefs } from 'vue';

import { useNpmData } from '@/composables/actions/useNpmData';

const value = defineModel('default');

const props = defineProps({
  query: {
    type: Object,
    required: false,
  },
  variables: {
    type: Object,
    required: false,
  },
  jsonSchema: {
    type: Object,
    required: false,
  },
  mcp: {
    type: String,
    required: false,
  },
  hideDefault: {
    type: Boolean,
    default: false,
  },
});

const { query, variables, jsonSchema, mcp } = toRefs(props);

const { hasNpmInstructions } = useNpmData(query.value);
const showNpmInstructions = computed(() => {
  return hasNpmInstructions(query.value);
});

const showTabs = computed(() => {
  // return true if at least two of the following are true
  return (
    [
      !!query.value,
      !!variables.value,
      !!showNpmInstructions.value,
      !!jsonSchema.value,
      !!mcp.value,
    ].filter((item) => item === true).length > 1
  );
});
</script>

<template>
  <Tabs
    v-if="showTabs"
    v-model:value="value"
    pt:root="rounded-lg w-full"
    :ptOptions="{ mergeProps: true }"
    class="mt-4 !inline-block pr-0"
    :show-navigators="false"
  >
    <TabList pt:tablist="gap-2" :ptOptions="{ mergeProps: true }">
      <Tab
        v-if="!hideDefault"
        value="default"
        pt:root="!rounded-md !px-2 !h-10 !mr-0 grow"
        :ptOptions="{ mergeProps: true }"
        >Form</Tab
      >
      <Tab
        value="gql"
        pt:root="!rounded-md !px-2 !h-10 !mr-0 grow"
        :ptOptions="{ mergeProps: true }"
        >GraphQL</Tab
      >
      <Tab
        v-if="showNpmInstructions"
        value="npm"
        pt:root="!rounded-md !px-2 !h-10 !mr-0 grow"
        :ptOptions="{ mergeProps: true }"
        >NPM</Tab
      >
      <Tab
        v-if="jsonSchema"
        value="input_specs"
        pt:root="!rounded-md !px-2 !h-10 !mr-0 grow"
        :ptOptions="{ mergeProps: true }"
        >Input spec</Tab
      >
      <Tab
        v-if="mcp"
        value="mcp"
        pt:root="!rounded-md !px-2 !h-10 !mr-0 grow"
        :ptOptions="{ mergeProps: true }"
        >MCP</Tab
      >
    </TabList>
  </Tabs>
</template>
